
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "result", "dailyChart", "bodyChart", "chartPreloader", "bodyTable", "calendar", "list", "dailyChartCard", "tableCard", "table", "indicators",
                    "dateDropdown", "dateDropdownBtn", "dateInput", "dateList", "footerData", "titleChart", "mainCard", "footerTable", "chartBodyTable", "totalChartCard",
                    "dailyTitleChart", "accrualTitleChart", "dailyChartBodyTable", "accrualChartBodyTable", "bodyDailyChart", "bodyAccrualChart", "accrualChart",
                    "dailyChartPreloader", "accrualChartPreloader", "accrualChartCard", "dateList", "dateCard", "reportPage", "dailyChartSource", "sourceCard", "source",
                    "gainSource", "prospectingSource", "lost", "reasonLost", "sourceLost", "lostCard", "productCard",
                    "typeCard", "gainStageBtn", "lostStageBtn", "personaCard", "persona", "chartCard", "downloadBtn", "asdf", "asdf", "asdf", "asdf", "asdf", "asdf", "asdf"]

  connect() {
    this.controllerName = `commercial--sales--opportunities--index--report`
    this.loader = this.getControllerByIdentifier("app--helpers--loaders").loader()
    this.cardLoader = this.getControllerByIdentifier("app--helpers--loaders").cardLoader()
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.sources = {}
    this.losts = {}
    this.typeCard = `table`
    this.opportunitiesTableCols = 12
    // this.doPageGrid()
  }

  doPageGrid() {
    
    var html = `<div class="row my-4 w-100" data-${this.controllerName}-target="reportPage">
                  <div class="col-1 px-1"></div>
                  <div class="col-11 px-0">
                    <div class="row">
                      <div class="col-2 px-1">
                        <div class="card pointer" data-${this.controllerName}-target="typeCard chartCard" data-feature="chart" data-action="click->${this.controllerName}#toggleReportCard">
                          <div class="card-header py-0 f-065 text-center">
                            <h6 class="card-title py-1" style="font-size:110%;margin-bottom:0px;"><strong>Evolução Mensal</strong></h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-2">
                        <div class="card pointer" data-${this.controllerName}-target="typeCard personaCard" data-feature="persona" data-action="click->${this.controllerName}#toggleReportCard">
                          <div class="card-header py-0 f-065 text-center">
                            <h6 class="card-title py-1" style="font-size:110%;margin-bottom:0px;"><strong>Análise Personas</strong></h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-2">
                        <div class="card pointer" data-${this.controllerName}-target="typeCard productCard" data-feature="product" data-action="click->${this.controllerName}#toggleReportCard">
                          <div class="card-header py-0 f-065 text-center">
                            <h6 class="card-title py-1" style="font-size:110%;margin-bottom:0px;"><strong>Análise Produtos</strong></h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-2">
                        <div class="card pointer" data-${this.controllerName}-target="typeCard sourceCard" data-feature="source" data-action="click->${this.controllerName}#toggleReportCard">
                          <div class="card-header py-0 f-065 text-center">
                            <h6 class="card-title py-1" style="font-size:110%;margin-bottom:0px;"><strong>Análise Fontes</strong></h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-2">
                        <div class="card pointer" data-${this.controllerName}-target="typeCard lostCard" data-feature="lost" data-action="click->${this.controllerName}#toggleReportCard">
                          <div class="card-header py-0 f-065 text-center">
                            <h6 class="card-title py-1" style="font-size:110%;margin-bottom:0px;"><strong>Análise Perdas</strong></h6>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-1">
                        <div class="card pointer" data-${this.controllerName}-target="typeCard tableCard" data-feature="table" data-action="click->${this.controllerName}#toggleReportCard">
                          <div class="card-header py-0 f-065 text-center">
                            <h6 class="card-title py-1" style="font-size:110%;margin-bottom:0px;"><strong>Relatório Oportunidades</strong></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1 px-1" data-${this.controllerName}-target="dateList" style="overflow:auto;"></div>
                  <div class="col-11 px-1">

                    <div class="row">
                      <div class="col-12 d-none px-0" data-controller="commercial--sales--opportunities--reports--chart" data-${this.controllerName}-target="chart" data-commercial--sales--opportunities--reports--chart-target="main"></div>
                    </div>

                    <div class="row">
                      <div class="col-12 d-none px-0" data-controller="commercial--sales--opportunities--reports--persona" data-${this.controllerName}-target="persona" data-commercial--sales--opportunities--reports--persona-target="main"></div>
                    </div>

                    <div class="row">
                      <div class="col-12 d-none px-0" data-controller="commercial--sales--opportunities--reports--product" data-${this.controllerName}-target="product" data-commercial--sales--opportunities--reports--product-target="main"></div>
                    </div>

                    <div class="row d-none" data-${this.controllerName}-target="source">
                      <div class="col-12 px-1">
                        <h6 class="mb-0 text-center">Ganhos por Fontes</h6>
                        <hr class="m-1">
                      </div>
                      <div class="col-12 px-0">
                        <div class="row" data-${this.controllerName}-target="gainSource"></div>
                      </div>
                      <div class="col-12 px-1 mt-3">
                        <h6 class="mb-0 text-center">Novas Oportunidades por Fontes</h6>
                        <hr class="m-1">
                      </div>
                      <div class="col-12 px-0">
                        <div class="row" data-${this.controllerName}-target="prospectingSource"></div>
                      </div>
                    </div>
                    <div class="row d-none" data-${this.controllerName}-target="lost">
                      <div class="col-12 px-1">
                        <h6 class="mb-0 text-center">Perdas por Motivos</h6>
                        <hr class="m-1">
                      </div>
                      <div class="col-12 px-0">
                        <div class="row" data-${this.controllerName}-target="reasonLost"></div>
                      </div>
                      <div class="col-12 px-1 mt-3">
                        <h6 class="mb-0 text-center">Perdas por Fontes</h6>
                        <hr class="m-1">
                      </div>
                      <div class="col-12 px-0">
                        <div class="row" data-${this.controllerName}-target="sourceLost"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 d-none px-0" data-${this.controllerName}-target="table">
                        <div class="row">
                          <div class="col-10 px-0" data-${this.controllerName}-target="list"></div>
                          <div class="col-2 px-1" data-${this.controllerName}-target="indicators">
                            <div class="col-12 mb-4">
                              ${this.cardLoader}
                            </div>
                            <div class="col-12 mb-4">
                              ${this.cardLoader}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`commercial--sales--opportunities--index--dashboard`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.dateListTarget.style.height = ($(window).height() * 0.5) + "px"
      controller.year = this.application.current_date.year
      controller.month = this.application.current_date.month
      controller.itemsOnPage = 300
      controller.pageNumber = 0
      controller.numberPages = []
      controller.sort = { mode: `desc`, field: `finished_at_to_time` }

      controller.typeCardTargets.forEach(card => {
        if (card.dataset.feature == controller.typeCard) {
          card.classList.add(`bg-primary`)
        }
      })
      controller.toggleReportCard()
      controller.doDateList()
      
      controller.setRequest()
    })
  }
  
  setRequest() {
    if (this.typeCard == "chart") {
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--chart`).year = this.year
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--chart`).month = this.month
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--chart`).doReportHtml()
    } else if (this.typeCard == "persona") {
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--persona`).year = this.year
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--persona`).month = this.month
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--persona`).doReportHtml()
    } else if (this.typeCard == "product") {
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--product`).year = this.year
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--product`).month = this.month
      this.getControllerByIdentifier(`commercial--sales--opportunities--reports--product`).doReportHtml()
    } else if (this.typeCard == "table") {
      this.doIndexListHtml()
    } else if (this.typeCard == "source") {
      this.requestSourceData()
    } else if (this.typeCard == "lost") {
      this.requestLostData()
    }
  }

  toggleReportCard(ev) {

    if (ev) {
      this.typeCard = ev.currentTarget.dataset.feature

      this.typeCardTargets.forEach(elementHtml => {
        elementHtml.classList.remove(`bg-primary`)
        this.nameTarget(elementHtml.dataset.feature).classList.add("d-none")
      })

      ev.currentTarget.classList.add(`bg-primary`)
      this.nameTarget(ev.currentTarget.dataset.feature).classList.remove("d-none")
    }

    this.nameTarget(`${this.typeCard}Card`).classList.add("bg-primary")
    this.nameTarget(`${this.typeCard}`).classList.remove("d-none")

    this.setRequest()

  }

  doDateList() {
    var listHtml = ``
    this.application.dates.forEach(element => {
      listHtml += `<div class="card pointer mb-2" data-${this.controllerName}-target="dateCard date-${element.id}" data-id="${element.id}" data-year="${element.year}" data-month="${element.month}" data-action="click->${this.controllerName}#toggleDate">
                    <div class="card-header py-1 f-065 text-center">
                      <h6 class="card-title py-1" style="font-size:110%;margin-bottom:0px;"><strong>${element.name_short}</strong></h6>
                    </div>
                  </div>`
    })

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.dateListTarget.innerHTML = listHtml)
    }).then(() => {
      controller.dateCardTargets.forEach(card => {
        if (card.dataset.id == controller.application.current_date.id) {
          card.classList.add(`bg-primary`)
        }
      })
    })
  }

  toggleDate(ev) {
    var toggleCard = ev.currentTarget

    this.dateCardTargets.forEach(card => {
      card.classList.remove(`bg-primary`)
    })

    toggleCard.classList.add(`bg-primary`)
    this.changeDate(ev)
  }

  changeDate(ev) {
    var toggleCard = ev.currentTarget

    var dateId = toggleCard.dataset.id
    this.year = toggleCard.dataset.year
    this.month = toggleCard.dataset.month
    this.setCurrentDate(dateId)
  }

  setCurrentDate(id) {
    this.application.dates.forEach(element => {
      if (element.id == id) {
        this.application.current_date = element
        this.application.current_calculation = element.calculation
        this.setRequest()
      }
    });
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doIndexListHtml() {
    var gainBtn = `<span class="badge badge-secondary-primary mx-2 pointer" data-action="click->${this.controllerName}#setOpportunitiesStage" data-${this.controllerName}-target="gainStageBtn" data-stage="gain">Ganhos</span>`
    var lostBtn = `<span class="badge badge-secondary-danger mx-2 pointer" data-action="click->${this.controllerName}#setOpportunitiesStage" data-${this.controllerName}-target="lostStageBtn" data-stage="lost">Perdas</span>`
    var downloadBtn = `<span class="pointer material-icons md-dark md-150 d-none" data-action="click->${this.controllerName}#downloadOpportunities" data-${this.controllerName}-target="downloadBtn">download</span>`

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Todas as Oportunidades | ${gainBtn} | ${lostBtn} ${downloadBtn}</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <div class="table-responsive">
                          <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                            <thead>
                              <tr>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-12 align-middle">
                                  Leads
                                  <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="account_name" data-mode="desc">south</span>
                                  <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="account_name" data-mode="asc">north</span>
                                </th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle text-center">Persona</th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle text-center">Produto</th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 text-center align-middle">
                                  SDR
                                  <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="prospector_name" data-mode="desc">south</span>
                                  <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="prospector_name" data-mode="asc">north</span>
                                </th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 text-center align-middle">
                                  Closer
                                  <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="closer_name" data-mode="desc">south</span>
                                  <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="closer_name" data-mode="asc">north</span>
                                </th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle">Fonte</th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Recorrente</th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Avulso</th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle">
                                  Estágio
                                  <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="stage_pretty" data-mode="desc">south</span>
                                  <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="stage_pretty" data-mode="asc">north</span>
                                </th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle">
                                  Data Final
                                  <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="finished_at_to_time" data-mode="desc">south</span>
                                  <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="finished_at_to_time" data-mode="asc">north</span>
                                </th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-3 align-middle">Prazo</th>
                                <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">Observações</th>
                                
                              </tr>
                            </thead>
                            <tbody data-${this.controllerName}-target="bodyTable">
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.listTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.5) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(controller.opportunitiesTableCols, 6))
      controller.selectStageMessage()
    })
  }

  selectStageMessage() {
    var message = `</tr>
                      <td colspan="${this.opportunitiesTableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Selecione o Relatório: (i) Ganhos ou (ii) Perdas</span>
                      </td>
                    </tr>`

    this.bodyTableTarget.innerHTML = message
    
    var indicators = `<div class="col-12 mb-4">
                        ${this.cardLoader}
                      </div>
                      <div class="col-12 mb-4">
                        ${this.cardLoader}
                      </div>`
    this.indicatorsTarget.innerHTML = indicators
  }

  setOpportunitiesStage(ev) {
    this.stage = ev.currentTarget.dataset.stage

    if (this.stage == `gain`) {
      this.stage_pretty = `Ganhos`
      this.gainStageBtnTarget.classList.remove(`badge-secondary-primary`)
      this.gainStageBtnTarget.classList.add(`badge-primary`)
      this.lostStageBtnTarget.classList.add(`badge-secondary-danger`)
      this.lostStageBtnTarget.classList.remove(`badge-danger`)

      this.downloadBtnTarget.classList.add(`d-none`)
    } else if (this.stage == `lost`) {
      this.stage_pretty = `Perdas`
      this.gainStageBtnTarget.classList.add(`badge-secondary-primary`)
      this.gainStageBtnTarget.classList.remove(`badge-primary`)
      this.lostStageBtnTarget.classList.remove(`badge-secondary-danger`)
      this.lostStageBtnTarget.classList.add(`badge-danger`)

      this.downloadBtnTarget.classList.remove(`d-none`)
    }

    this.requestOpportunities(this.stage)
  }

  doDataTable() {
    var current_opportunities = this.opportunities

    if (this.sort.mode == `asc`) {
      var opportunities = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_opportunities, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var opportunities = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(current_opportunities, this.sort.field)
    }

    if (opportunities.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(opportunities.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (opportunities[x] !== undefined) {
            internPage[internPage.length] = opportunities[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: opportunities.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="${this.opportunitiesTableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há ${this.stage_pretty} de Oportunidades na ${this.application.current_date.name}</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.opportunityTablePartial(element, data.length))
      });
    }

    if (this.checked_id) {
      this.checkboxShowTargets.forEach(element => {
        if (element.id == `check-${this.checked_id}`) {
          element.checked = true
        }
      })
    }
  }

  opportunityTablePartial(element, length) {

    element.name = ``
    element.ticket_name = ``
    element.leads.forEach(lead => {
      element.ticket_name += `<p class="mb-0 f-065">${lead.lead_name}</p>`
      element.name += `<p class="mb-0 f-065 f-bold" data-${this.controllerName}-target="opportunityLeadName">${lead.lead_name}</p>`
    })

    element.product_name_pretty = `<p class="mb-0 f-065 f-bold" data-${this.controllerName}-target="opportunityProductName">${element.product_name_pretty} | ${element.product_kind_pretty}</p>`

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-opportunity-id="${element.opportunity_id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-opportunity-id="${element.opportunity_id}">`
    }

    if (element.prospector_name == null || element.prospector_name == undefined) {
      element.prospector_name = `Não Definido`
    }

    if (element.closer_name == null || element.closer_name == undefined) {
      element.closer_name = `Não Definido`
    }

    if (this.stage == `gain`) {
      var recurringAmount = element.total_gain_recurring
      var separateAmount = element.total_gain_separate
      var help = `Ganho`
    } else if (this.stage == `lost`) {
      var recurringAmount = element.total_lost_recurring
      var separateAmount = element.total_lost_separate
      var help = element.product_lost_reason
    }
    // `<td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.getControllerByIdentifier("app--helpers--numbers").currencyMask(parseInt(element.total_amount_recurring * 100))}</td>
    //  <td style="font-size:60%;" scope="col" class="p-1 align-middle">
    //    <p class="mb-0 f-065 mc-tooltip pointer">
    //      <span data-controller="app--helpers--copy" data-copy="${element.token}" data-action="click->app--helpers--copy#copy">${element.token}</span>
    //      <span class="mc-tooltiptext">Clique para Copiar</span>
    //    </p>
    //  </td>`

    if (this.application.permissions.sales_opportunities_entities.can_assign) {
      var edit = `<button data-action="click->${this.controllerName}#editOpportunities" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                    <span class="material-icons md-sm md-dark">settings</span>
                    <span class="mc-tooltiptext">Ajustar</span>
                  </button>`
    } else {
      var edit = ``
    }
    var edit = ``

    if (element.product_recurring) {
      var productRecurring = `Recorrente`
    } else {
      var productRecurring = `Avulso`
    }

    var kindPretty = ``
    if (element.kind == null) {
      kindPretty = `<span class="mb-0 f-065 mc-tooltip">
                      <span class="pointer" data-action="click->${this.controllerName}#editKindModal">${element.kind_pretty}</span>
                      <span class="mc-tooltiptext mc-tooltiptext-right">Editar Persona</span>
                    </span>`
    } else {
      kindPretty = element.kind_pretty
    }
    
    var rowHtml = `${tableRow}
                    
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer">
                      <span class="mb-0 f-065 mc-tooltip">
                        <span data-token="${element.token}" data-action="click->${this.controllerName}#goToShowPage">${element.name}</span>
                        <span class="mc-tooltiptext mc-tooltiptext-right">Clique para Ver Oportunidade</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${kindPretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">
                      <span class="mb-0 f-065 mc-tooltip">
                        <span>${element.product_name_pretty}</span>
                        <span class="mc-tooltiptext">${productRecurring}</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">
                      <span class="mb-0 f-065 mc-tooltip helper">
                        <span>${element.prospector_nickname}</span>
                        <span class="mc-tooltiptext mc-tooltiptext-right">${element.prospector_name}</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">
                      <span class="mb-0 f-065 mc-tooltip helper">
                        <span>${element.closer_nickname}</span>
                        <span class="mc-tooltiptext mc-tooltiptext-right">${element.closer_name}</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.source_pretty}</td>
                    
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(recurringAmount)}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(separateAmount)}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.journeys[1].stage_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.finished_at_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.closing_term}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${help}</td>
                    
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="row">
                        <div class="col-2 d-flex">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span data-app--helpers--search-target="footerTable"></span>
                          </div>
                        </div>
                        <div class="col-10 px-0">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                            <div class="dropdown">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${this.controllerNumber.numberMask(pagination.itemsOnPage)}</button>
                              <div class="dropdown-menu dropdown-menu-right menu">
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="300">300</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="750">750</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="1000">1.000</span>
                              </div>
                            </div>
                            <span class="align-self-center mb-1 mr-2 text-muted">${this.controllerNumber.numberMask(pagination.fromItem)}-${this.controllerNumber.numberMask(pagination.toItem)} de ${this.controllerNumber.numberMask(pagination.totalItems)}</span>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                          </div>
                        </div>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  goToShowPage(ev) {
    var token = ev.currentTarget.dataset.token
    window.open(`/a/oportunidades/${token}`, `_blank`)
  }

  doDataIndicators() {
    var recurring = 0
    var nonRecurring = 0
    var gainRecurringOpportunities = 0
    var gainRecurringClosingTerm = 0
    var gainRecurringTotalClosingTerm = 0
    var gainNonRecurringOpportunities = 0
    var gainNonRecurringClosingTerm = 0
    var gainNonRecurringTotalClosingTerm = 0
    this.opportunities.forEach(element => {
      if (this.stage == `gain`) {
        if (element.product_recurring) {
          gainRecurringOpportunities += 1
          gainRecurringTotalClosingTerm += element.closing_term
        } else {
          gainNonRecurringOpportunities += 1
          gainNonRecurringTotalClosingTerm += element.closing_term
        }
        
        recurring += Number(element.total_gain_recurring)
        nonRecurring += Number(element.total_gain_separate)
      } else if (this.stage == `lost`) {
        if (element.product_recurring) {
          gainRecurringOpportunities += 1
          gainRecurringTotalClosingTerm += element.closing_term
        } else {
          gainNonRecurringOpportunities += 1
          gainNonRecurringTotalClosingTerm += element.closing_term
        }
        
        recurring += Number(element.total_lost_recurring)
        nonRecurring += Number(element.total_lost_separate)
      }
    })

    if (gainRecurringOpportunities > 0) {
      gainRecurringClosingTerm = (gainRecurringTotalClosingTerm / gainRecurringOpportunities)
    } else {
      gainRecurringClosingTerm = 0
    }

    if (gainNonRecurringOpportunities > 0) {
      gainNonRecurringClosingTerm = (gainNonRecurringTotalClosingTerm / gainNonRecurringOpportunities)
    } else {
      gainNonRecurringClosingTerm = 0
    }

    var html = `<div class="row">
                  <div class="col-12 mb-4">
                    <div class="card">
                      <div class="card-header p-1 text-center f-075 f-bold">
                        <span>Recorrente</span>
                      </div>
                      <div class="card-body text-center f-075 px-0 py-1">
                        <div class="row my-3 d-flex align-items-center">
                          <div class="col-12 f-1 px-1">
                            ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(recurring)}
                          </div>
                          <div class="col-12 f-1 px-1 f-075">
                            <span class="f-075">${this.getControllerByIdentifier("app--helpers--numbers").numberMask(gainRecurringClosingTerm)} dias</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-4">
                    <div class="card">
                      <div class="card-header p-1 text-center f-075 f-bold">
                        <span>Não-Recorrente</span>
                      </div>
                      <div class="card-body text-center f-075 px-0 py-1">
                        <div class="row my-3 d-flex align-items-center">
                          <div class="col-12 f-1 px-1">
                            ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(nonRecurring)}
                          </div>
                          <div class="col-12 f-1 px-1 f-075">
                            <span class="f-075">${this.getControllerByIdentifier("app--helpers--numbers").numberMask(gainNonRecurringClosingTerm)} dias</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>`

    this.indicatorsTarget.innerHTML = html
  }

  editKindModal(ev) {
    var opportunityId = ev.currentTarget.closest(`.itemRow`).dataset.opportunityId
    var modalName = `commercial--sales--opportunities--entities--save-kind-modal`

    var html = `<div class="modal fade" data-controller="${modalName}" data-${modalName}-target="modal" id="modal" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div class="modal-content">
                      <div class="modal-body p-0" data-${modalName}-target="body"></div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {

      controller.getControllerByIdentifier(modalName).opportunity_id = opportunityId
      controller.getControllerByIdentifier(modalName).controllerForm = controller
      controller.getControllerByIdentifier(modalName).open()
    })
  }

  setOpportunities() {
    this.opportunities = []
    this.report_opportunities.forEach(element => {
      // if (element.stage == `gain` && element.date_id == this.application.current_date.id) {
      if (element.date_id == this.application.current_date.id) {
        this.opportunities[this.opportunities.length] = element
      }
    })

    this.doDataTable()
    this.doDataIndicators()
  }

  setSources() {
    var gainSourceHtml = ``
    var prospectingSourceHtml = ``
    this.sources.report_by_gain.forEach(report => {
      gainSourceHtml += `<div class="col-2 px-1 my-2">
                              <div class="card border-top-primary">
                                <div class="card-header p-1 text-center f-065">
                                  <span>${report.header_name}</span>
                                </div>
                                <div class="card-body text-center py-2 mc-tooltip pointer">
                                  <span class="f-085">${report.total}</span><br>
                                  <span class="f-085 f-bold">${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(report.amount)}</span>
                                </div>
                              </div>
                            </div>`
    })
    this.sources.report_by_prospecting.forEach(report => {
      prospectingSourceHtml += `<div class="col-2 px-1 my-2">
                              <div class="card border-top-primary">
                                <div class="card-header p-1 text-center f-065">
                                  <span>${report.header_name}</span>
                                </div>
                                <div class="card-body text-center py-2 mc-tooltip pointer">
                                  <span class="f-085">${report.total}</span><br>
                                  <span class="f-085 f-bold">${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(report.amount)}</span>
                                </div>
                              </div>
                            </div>`
    })
    this.gainSourceTarget.innerHTML = gainSourceHtml
    this.prospectingSourceTarget.innerHTML = prospectingSourceHtml
  }

  setLosts() {
    var reasonLostHtml = ``
    var sourceLostHtml = ``
    this.losts.report_by_reason.forEach(report => {
      var cardShow = ``
      report.sources.forEach(source => {
        cardShow += `<p class="mb-0 f-065">${source.header_name} | ${source.total} | ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(source.amount)}</p>`
      });

      reasonLostHtml += `<div class="col-2 px-1 my-2">
                              <div class="card border-top-primary">
                                <div class="card-header p-1 text-center f-065">
                                  <span>${report.header_name}</span>
                                </div>
                                <div class="card-body text-center py-2 mc-tooltip pointer">
                                  <div class="card-show-dropdown w-100">
                                    <span class="f-085">${report.total}</span><br>
                                    <span class="f-085 f-bold">${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(report.amount)}</span>
                                    <div class="card-show-dropdown-content text-left">
                                      ${cardShow}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>`
    })
    this.losts.report_by_source.forEach(report => {
      sourceLostHtml += `<div class="col-2 px-1 my-2">
                              <div class="card border-top-primary">
                                <div class="card-header p-1 text-center f-065">
                                  <span>${report.header_name}</span>
                                </div>
                                <div class="card-body text-center py-2 mc-tooltip pointer">
                                  <span class="f-085">${report.total}</span><br>
                                  <span class="f-085 f-bold">${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(report.amount)}</span>
                                </div>
                              </div>
                            </div>`
    })
    this.reasonLostTarget.innerHTML = reasonLostHtml
    this.sourceLostTarget.innerHTML = sourceLostHtml
  }

  requestSourceData() {
    var date = new Date(this.year, this.month - 1, 1)
    const data = { source: { date_string: date, account_id: this.application.account_id }, current_user: { current_user_id: this.application.current_user.id } }
    const url = "/commercial/sales/opportunities/reports/source_report"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        response.data.cln.forEach(report => {
          controller.sources[report.name] = report.data
        })

        controller.setSources()
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  requestLostData() {
    var date = new Date(this.year, this.month - 1, 1)
    const data = { source: { date_string: date, account_id: this.application.account_id }, current_user: { current_user_id: this.application.current_user.id } }
    const url = "/commercial/sales/opportunities/reports/lost_report"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        response.data.cln.forEach(report => {
          controller.losts[report.name] = report.data
        });
        controller.setLosts()
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  requestOpportunities() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal({ message: `Em processamento, aguarde!` })

    var date = new Date(this.year, this.month - 1, 1)
    const data = { transaction: { active: true, stage: this.stage, date_string: date, account_id: this.application.account_id }, current_user: { current_user_id: this.application.current_user.id } }
    const url = "/commercial/sales/opportunities/transactions/list_by_date_and_stage"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.report_opportunities = response.data.cln
        controller.opportunities_ids = controller.mapElements(response.data.cln, `opportunity_id`)
        controller.setOpportunities()

        console.log(controller.opportunities_ids)
        
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  downloadOpportunities() {
    
    if (this.opportunities_ids.length > 0) {
      this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal({ message: `Em processamento, aguarde!` })

      const data = { opportunity: { ids: this.opportunities_ids }, current_user: { current_user_id: this.application.current_user.id, feature: `sales_opportunities_entities` } }
      const url = "/commercial/sales/opportunities/entities/download"
      const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
      var controller = this
      fetch(url, init)
        .then(response => response.json())
        .then(response => {
          var date = new Date()
          var fileName = `base-oportunidades-${date.getTime()}`
          var fileExtension = `csv`

          if (response.process) {
            controller.getControllerByIdentifier("app--helpers--csv").processingCsv(response, fileName, fileExtension)
          }

          controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
        })
        .catch(error => {
          controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
        })  
    } else {
      var message = `Favor selecionar o relatório de Perdas!`
      this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", message, 5000)
    }
    
  }

  goTo(ev) {
    var url = ev.target.dataset.url
    window.open(url, '_self');
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    })
    return results
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 



}
